import {connect} from "react-redux";
import * as AdminActions from '../../../store/actions/adminActions';
import DashboardAdmin from '../../../components/Dashboard/DashboardAdmin/DashboardAdmin';
import * as CoursesActions from '../../../store/actions/coursesActions';
import * as VideoActions from '../../../store/actions/videoActions';
import * as AppActions from '../../../store/actions/appActions';

const mapStateToProps = (state) => ({
    ...state,
    ...state.courses,
    ...state.auth,
    ...state.events,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    onLoadInfo: () => {
        dispatch(AdminActions.getInfoForAdmin());
    },
    buildChart: (courseId, view, length, token) => {
        dispatch(CoursesActions.getChart(courseId, view, length, token));
    },
    hideLoader: () => {
        dispatch(AppActions.appLoading(false));
    },
    getCourseUsers: (profileId, token) => {
        dispatch(VideoActions.getCourseUser(profileId, token));
    },
    getStudents: (token) => {
        dispatch(CoursesActions.getStudents(token));
    },
    onLoadCourses: (uid, token) => {
        dispatch(CoursesActions.getCoursesForAdmin(uid, token));
    },
    getCourseUsersByCourseId: (courseId, token) => {
        dispatch(CoursesActions.getCourseUsersByCourseId(courseId, token));
    },
    createEvent: (event, uid, token) => {
        dispatch(CoursesActions.createEvent(event, uid, token));
    },
    getEvents: (uid, token) => {
        dispatch(CoursesActions.getEvents(uid, token));
    },
    updateCourseUser: (courseUser, token) => {
        dispatch(CoursesActions.updateCourseUser(courseUser, token));
    },
    removeCourseUser: (id, token) => {
        dispatch(CoursesActions.removeCourseUser(id, token));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardAdmin);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardAdmin/DashboardAdminContainer.js